import React, { useMemo, useEffect, useState } from "react";
import {
  useTable,
  useResizeColumns,
  useFlexLayout,
  usePagination,
} from "react-table";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ContantLoader from "./ContantLoader";
import './styles.css';

const Table = ({
  columns,
  data,
  rowClickFunction,
  fetchData,
  table_type,
  loading,
  pageCount: controlledPageCount,
  onRowClick 
}) => {
  const defaultColumn = useMemo(
    () => ({
      // When using the useFlexLayout:
      minWidth: 150, // minWidth is only used as a limit for resizing
      width: 150, // width is used for both the flex-basis and flex-grow
      maxWidth: 400, // maxWidth is only used as a limit for resizing
    }),
    []
  );

  const headerProps = (props, { column }) => getStyles(props, column.align);

  const cellProps = (props, { cell }) => getStyles(props, cell.column.align);

  const getStyles = (props, align = "left") => [
    props,
    {
      style: {
        justifyContent: align === "right" ? "flex-end" : "flex-start",
        alignItems: "flex-center",
        display: "flex",
      },
    },
  ];

  const {
    getTableProps,
    headerGroups,
    rows,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      initialState: { pageIndex: 0, pageSize: 50 },
      manualPagination: true,
      pageCount: controlledPageCount,
    },
    useResizeColumns,
    useFlexLayout,
    usePagination
  );

  useEffect(() => {
    fetchData({ pageIndex, pageSize });
  }, [pageIndex, pageSize]);

  return (
    <>
      {loading ? (
        <ContantLoader />
      ) : (
        <div className="table-responsive" style={{ height: "auto" }}>
          {
            <table className="table" id="tableID" {...getTableProps()}>
              <thead>
                <div>
                  {headerGroups.map((headerGroup) => (
                    <tr
                      {...headerGroup.getHeaderGroupProps({
                        // style: { paddingRight: '15px' },
                      })}
                    >
                      {headerGroup.headers.map((column) => (
                        <th {...column.getHeaderProps(headerProps)}>
                          {column.render("Header")}
                          {column.canResize && (
                            <div
                              {...column.getResizerProps()}
                              className={`resizer ${column.isResizing ? "isResizing" : ""
                                }`}
                            />
                          )}
                        </th>
                      ))}
                    </tr>
                  ))}
                </div>
              </thead>
              <tbody>
                {page.map((row) => {
                  prepareRow(row);
                  let strike = row.original && row.original.strike

                  return (
                    <tr

                      className="table-row"
                      {...row.getRowProps()}
                      onClick={(e) => {
                        if (table_type == "AllTemplate") {
                          rowClickFunction &&
                            rowClickFunction({
                              id: row.original.id,
                              type: row.original.type,
                            });
                        } else if (table_type == "AllTriggers") {
                          rowClickFunction && rowClickFunction(row.original.id);
                        }

                    if( onRowClick ){
                      onRowClick(e, row.original)
                    }

                        // else if (table_type == "AllWorkflows") {
                        //   rowClickFunction &&
                        //     rowClickFunction({
                        //       id: row.original.id,
                        //     });
                        // }
                      }}
                      {...row.getRowProps()}
                    >
                                                        {strike && <div className="strike-line" ></div>}

                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps(cellProps)}>
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          }
          {/* Pagination */}
          <div className="pagination">
            <select
              value={pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
              }}
            >
              {[50, 100, 150, 200, 250].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
            <button
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
              className="gotofirst"
            >
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    First Page
                  </Tooltip>
                )}
              >
                <i className="fa fa-angle-double-left"></i>
              </OverlayTrigger>
            </button>
            <button
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              className="gotoprevious"
            >
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    Previous
                  </Tooltip>
                )}
              >
                <i className="fa fa-angle-left"></i>
              </OverlayTrigger>
            </button>{" "}
            <button
              onClick={() => nextPage()}
              disabled={!canNextPage}
              className="gotonext"
            >
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    Next
                  </Tooltip>
                )}
              >
                <i className="fa fa-angle-right"></i>
              </OverlayTrigger>
            </button>{" "}
            <button
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
              className="gotolast"
            >
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    Last Page
                  </Tooltip>
                )}
              >
                <i className="fa fa-angle-double-right"></i>
              </OverlayTrigger>
            </button>{" "}
          </div>
        </div>
      )}
    </>
  );
};

export default Table;
